<template>
  <nuttrema-layout-three-vertical>

    <participant-standard-header
       slot="top"
      :meta="meta"
      :showOnMobileAndTablet="showOnMobileAndTablet">
    </participant-standard-header>

    <template slot="middle">
      <form-forgot-password
         class="is-center-vertical"
        :AuthenticationForgotPassword="AuthenticationForgotPassword"
        @submit="onFormSubmit">
      </form-forgot-password>
    </template>

  </nuttrema-layout-three-vertical>
</template>

<script>
import ResponsiveMonitor from 'components/mixins/responsive-monitor';
import ParticipantStandardHeader from 'components/pages/participant/shared/participant-standard-header';
import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';

import PageForgotPassword from 'components/pages/shared/forgot-password/page-forgot-password';

export default {
  name: 'page-participant-forgot-password',
  mixins: [
    ResponsiveMonitor,
    PageForgotPassword,
  ],
  components: {
    ParticipantStandardHeader,
    NuttremaLayoutThreeVertical,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/participant/public/forgot-password/page-participant-forgot-password.vue